import * as Types from './contentfulTypes';

import gql from 'graphql-tag';
import * as ApolloReactCommon from 'react-apollo';
export const DdpImageAssetFragmentDoc = gql`
    fragment DdpImageAsset on Asset {
  sys {
    id
  }
  title
  description
  width
  height
  url
}
    `;
export const DdpEntrySysInfoFragmentDoc = gql`
    fragment DdpEntrySysInfo on Entry {
  __typename
  sys {
    id
  }
}
    `;
export const DdpIconLabelFragmentDoc = gql`
    fragment DdpIconLabel on GeneralIconLabel {
  iconLabel
  description
  iconVariant
}
    `;
export const DdpAboutEntryFragmentDoc = gql`
    fragment DdpAboutEntry on Entry {
  ...DdpEntrySysInfo
  ...DdpIconLabel
}
    ${DdpEntrySysInfoFragmentDoc}
${DdpIconLabelFragmentDoc}`;
export const DdpAssetSysInfoFragmentDoc = gql`
    fragment DdpAssetSysInfo on Asset {
  __typename
  sys {
    id
  }
}
    `;
export const DdpValuePropEntryFragmentDoc = gql`
    fragment DdpValuePropEntry on Asset {
  ...DdpAssetSysInfo
  ...DdpImageAsset
}
    ${DdpAssetSysInfoFragmentDoc}
${DdpImageAssetFragmentDoc}`;
export const DdpFaqFragmentDoc = gql`
    fragment DdpFAQ on Faq {
  sectionName
  question
  subtitle
  answer
}
    `;
export const DdpFieldsAboveFoldFragmentDoc = gql`
    fragment DdpFieldsAboveFold on UniversityProgramDegreeDescriptionPage {
  slug
  countryCode
  languageCode
  variant
  template
  programName
  shortName
  programCategoryId
  partner {
    partnerName
    partnerSlug
    partnerSummary
    partnerLogo {
      ...DdpImageAsset
    }
    partnerMonotoneLogo {
      ...DdpImageAsset
    }
    partnerSquareLogo {
      ...DdpImageAsset
    }
    bannerImage {
      ...DdpImageAsset
    }
  }
  expressionOfInterest {
    applyButtonText
    applyButtonUrl
    emailMeButtonText
    emailMeConfirmationText
    emailMeFormHeaderText
    hostedApplicationUrl
    productEnrollmentFlow
    programInterestText
    inlineTitle
    inlineDescription
  }
  atAGlance {
    finalDeadlineInfo
    bannerAtAGlanceTitle1
    bannerAtAGlanceDescription1
    bannerAtAGlanceTitle2
    bannerAtAGlanceDescription2
    bannerAtAGlanceTitle3
    bannerAtAGlanceDescription3
    bannerAtAGlanceTitle4
    bannerAtAGlanceDescription4
    bannerAtAGlanceTitle5
    bannerAtAGlanceDescription5
  }
  tuitionCurrency
  tuitionPrice
  bannerNotification {
    json
  }
  backgroundImage {
    ...DdpImageAsset
  }
  overviewAbout {
    json
    links {
      entries {
        block {
          ...DdpAboutEntry
        }
      }
    }
  }
  admissionsAbout {
    json
    links {
      entries {
        block {
          ...DdpAboutEntry
        }
      }
    }
  }
  academicsAbout {
    json
    links {
      entries {
        block {
          ...DdpAboutEntry
        }
      }
    }
  }
  tuitionAbout {
    json
    links {
      entries {
        block {
          ...DdpAboutEntry
        }
      }
    }
  }
  careersAbout {
    json
    links {
      entries {
        block {
          ...DdpAboutEntry
        }
      }
    }
  }
  studentExperienceAbout {
    json
    links {
      entries {
        block {
          ...DdpAboutEntry
        }
      }
    }
  }
  overviewValueProp {
    json
    links {
      assets {
        block {
          ...DdpValuePropEntry
        }
      }
    }
  }
  financeSection {
    title
    description
    callToActionLabel
    callToActionLink
  }
  testimonialsCollection {
    items {
      image {
        title
        description
        url
        width
        height
      }
      videoEmbedUrl
      videoPlaceholderImage {
        ...DdpImageAsset
      }
      authorName
      authorTitle
      authorOrganization
      text
    }
  }
  overviewValueProp2 {
    json
    links {
      assets {
        block {
          ...DdpValuePropEntry
        }
      }
    }
  }
  upsellsAbout {
    title
    description
    visual {
      ...DdpImageAsset
    }
    callToActionLabel
    callToActionLink
  }
  earnCreditsNowUpsellsText {
    json
  }
  partOfUpsellsText {
    json
  }
  relatedToUpsellsText {
    json
  }
  faqCollection {
    items {
      ...DdpEntrySysInfo
      ...DdpFAQ
    }
  }
}
    ${DdpImageAssetFragmentDoc}
${DdpAboutEntryFragmentDoc}
${DdpValuePropEntryFragmentDoc}
${DdpEntrySysInfoFragmentDoc}
${DdpFaqFragmentDoc}`;
export const NewsItemFragmentDoc = gql`
    fragment NewsItem on UniversityProgramNewsItem {
  ...DdpEntrySysInfo
  title
  body {
    json
  }
  postDate
  url
  readLength
}
    ${DdpEntrySysInfoFragmentDoc}`;
export const MarketingContentItemFragmentDoc = gql`
    fragment MarketingContentItem on MarketingContent {
  title
  description
  callToActionLink
}
    `;
export const PathwayBlockFragmentDoc = gql`
    fragment PathwayBlock on UniversityProgramPathwayBlock {
  title
  description
  programListCollection {
    items {
      ...DdpEntrySysInfo
      productId
      productType
      title
      courseLength
      productUrl
    }
  }
}
    ${DdpEntrySysInfoFragmentDoc}`;
export const DdpProductCardFragmentDoc = gql`
    fragment DdpProductCard on GeneralProductCard {
  productId
  productType
  title
  courseLength
  productUrl
  description
  productImage {
    ...DdpAssetSysInfo
    ...DdpImageAsset
  }
  productLengthOverrideText
}
    ${DdpAssetSysInfoFragmentDoc}
${DdpImageAssetFragmentDoc}`;
export const InstructorProfileItemFragmentDoc = gql`
    fragment InstructorProfileItem on InstructorProfile {
  name
  position
  profilePicture {
    ...DdpAssetSysInfo
    ...DdpImageAsset
  }
}
    ${DdpAssetSysInfoFragmentDoc}
${DdpImageAssetFragmentDoc}`;
export const DdpFieldsBelowFoldFragmentDoc = gql`
    fragment DdpFieldsBelowFold on UniversityProgramDegreeDescriptionPage {
  latestNews {
    json
    links {
      entries {
        block {
          ...DdpEntrySysInfo
          ...NewsItem
        }
      }
    }
  }
  careerSection {
    json
    links {
      entries {
        inline {
          ...DdpEntrySysInfo
          ...DdpIconLabel
        }
        block {
          ...DdpEntrySysInfo
          ...MarketingContentItem
        }
      }
    }
  }
  upcomingEventsCollection {
    items {
      ...DdpEntrySysInfo
      title
      eventDate
      recurrenceFrequency
      eventDescription
      ctaTitle
      ctaUrl
    }
  }
  deadlineSectionCollection {
    items {
      ...DdpEntrySysInfo
      title
      deadlineType
      enrollApplyStart
      enrollApplyEnd
      enrollApplyCustomText
      coursesStart
      coursesStartCustomText
    }
  }
  pathwaySection {
    json
    links {
      entries {
        block {
          ...DdpEntrySysInfo
          ...PathwayBlock
        }
      }
    }
  }
  admissionsProcess {
    json
    links {
      entries {
        block {
          ...DdpEntrySysInfo
          ...DdpProductCard
          ...DdpFAQ
        }
      }
    }
  }
  academicsValueProp {
    json
    links {
      assets {
        block {
          ...DdpValuePropEntry
        }
      }
    }
  }
  academicBlocksCollection {
    items {
      ...DdpEntrySysInfo
      ...DdpFAQ
    }
  }
  tuitionValueProp {
    json
    links {
      assets {
        block {
          ...DdpValuePropEntry
        }
      }
    }
  }
  tuitionGridLinks {
    json
    links {
      entries {
        block {
          ...DdpEntrySysInfo
          ...MarketingContentItem
        }
      }
    }
  }
  careersValueProp {
    json
    links {
      assets {
        block {
          ...DdpValuePropEntry
        }
      }
    }
  }
  studentExperienceInfoListCollection {
    items {
      sys {
        id
      }
      title
      description
      visual {
        ...DdpAssetSysInfo
        ...DdpImageAsset
      }
    }
  }
  instructorsSection {
    json
    links {
      entries {
        block {
          ...DdpEntrySysInfo
          ...InstructorProfileItem
        }
      }
    }
  }
  studentExperienceValueProp {
    json
    links {
      assets {
        block {
          ...DdpValuePropEntry
        }
      }
    }
  }
}
    ${DdpEntrySysInfoFragmentDoc}
${NewsItemFragmentDoc}
${DdpIconLabelFragmentDoc}
${MarketingContentItemFragmentDoc}
${PathwayBlockFragmentDoc}
${DdpProductCardFragmentDoc}
${DdpFaqFragmentDoc}
${DdpValuePropEntryFragmentDoc}
${DdpAssetSysInfoFragmentDoc}
${DdpImageAssetFragmentDoc}
${InstructorProfileItemFragmentDoc}`;
export const DdpContentAboveFoldDocument = gql`
    query DdpContentAboveFold($slug: String!, $countryCode: String!, $languageCode: String!, $variant: String!, $preview: Boolean!) {
  universityProgramDegreeDescriptionPageCollection(
    where: {slug: $slug, countryCode: $countryCode, languageCode: $languageCode, variant: $variant}
    limit: 1
    preview: $preview
  ) {
    items {
      ...DdpFieldsAboveFold
    }
  }
}
    ${DdpFieldsAboveFoldFragmentDoc}`;
export type DdpContentAboveFoldQueryResult = ApolloReactCommon.QueryResult<Types.DdpContentAboveFoldQuery, Types.DdpContentAboveFoldQueryVariables>;
export const DdpContentBelowFoldDocument = gql`
    query DdpContentBelowFold($slug: String!, $countryCode: String!, $languageCode: String!, $variant: String!, $preview: Boolean!) {
  universityProgramDegreeDescriptionPageCollection(
    where: {slug: $slug, countryCode: $countryCode, languageCode: $languageCode, variant: $variant}
    limit: 1
    preview: $preview
  ) {
    items {
      ...DdpFieldsBelowFold
    }
  }
}
    ${DdpFieldsBelowFoldFragmentDoc}`;
export type DdpContentBelowFoldQueryResult = ApolloReactCommon.QueryResult<Types.DdpContentBelowFoldQuery, Types.DdpContentBelowFoldQueryVariables>;